module.exports = __webpack_public_path__ + "media/images/app/products/Earrings_marshmallows-ab816a4c10946e42eef51b211f1003ef.webp";